import { useQuery } from '@tanstack/react-query';
import { dataSourceRoot, getDataSource } from '../data/dataSourceFactory';
import { toSeries } from '../data/types';
import { viewableSeries } from '../data/derivedSeries';

/** QIDO series list for a study: its images. What an AI model derived from
 *  them (SEG, SR series) is left out — the AI tab shows it. */
export function useSeries(studyInstanceUID: string | undefined) {
  return useQuery({
    queryKey: ['series', dataSourceRoot(), studyInstanceUID],
    enabled: !!studyInstanceUID,
    queryFn: async () => {
      const datasets = await getDataSource().searchSeries(studyInstanceUID!);
      return viewableSeries(datasets.map(toSeries).filter((s) => s.seriesInstanceUID));
    },
  });
}
